/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import {Component, OnInit} from '@angular/core';
import { NbToastrService } from '@nebular/theme';
import { ErrorService } from './@core/services/error/error.service';
import { Destroy } from './@core/services/destroy.service';
import { takeUntil } from 'rxjs/operators';
import {environment} from '../environments/environment';
import {CacheService} from './@core/services/store/cache.service';

@Component({
  selector: 'ngx-app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [ Destroy ],
})
export class AppComponent implements OnInit {
  message: string;
  show = false;

  constructor(
    private readonly errorService: ErrorService,
    private readonly toastrService: NbToastrService,
    private readonly destroyed: Destroy,
    private readonly cacheService: CacheService, // necessary to instantiate the service application wide
  ) {}

  ngOnInit() {
    this.errorService.error.pipe(takeUntil(this.destroyed)).subscribe((error) => {
      this.toastrService.danger(error.message, error.name);
    });
    if(!environment.production) {
      this.show = true;
      this.message = 'environnement de test';
    }
  }
}
